module.exports = __webpack_public_path__ + "img/home-location.3f682831.png";